<template>
  <div class="h-100">
    <LGTopo
      :nome-portal="dadosLayout.nomePortal"
      :logotipo="dadosLayout.logotipo"
      :menu="dadosLayout.menus"
      :produtos="dadosLayout.produtos"
      :usuario="dadosLayout.usuario"
      :itens-pesquisados="itensPesquisados"
      :mostrar-botao-pesquisa-mobile="mostrarBotaoPesquisaMobile"
      :menu-usuario-modo-sidebar="menuUsuarioModoSidebar"
      @upload-foto="alterarFoto"
      @pesquisar="$emit('pesquisar', $event)"
      @pesquisar-change="$emit('pesquisar-change', $event)"
    >
      <template #acoes>
        <slot name="acoes" />
      </template>
    </LGTopo>

    <section class="lg-aa-layout__conteudo">
      <section class="lg-aa-layout__conteudo__main">
        <router-view />
        <slot name="extensoes" />
      </section>
    </section>

    <LGRodape />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import LGTopo from 'lg-vue-components/topo';
import LGRodape from 'lg-vue-components/rodape';

export default {
  name: 'LGLayoutPadrao',
  components: {
    LGTopo,
    LGRodape,
  },
  props: {
    itensPesquisados: {
      type: Array,
      default: null,
    },
    mostrarBotaoPesquisaMobile: {
      type: Boolean,
      default: true,
    },
    menuUsuarioModoSidebar: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'pesquisar',
    'pesquisar-change',
  ],
  data() {
    return {
      componenteVue: true,
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      dadosLayout: 'layout/getDadosLayout',
    }),
    usuarioConfiguracao() {
      return this.$store.state.layout.usuario.configuracao;
    },
  },
  methods: {
    alterarFoto() {
      if (this.usuarioConfiguracao.alterarFoto) {
        if (this.$attrs.onUploadFoto) {
          this.$attrs.onUploadFoto();
        } else {
          const ref = this;

          // eslint-disable-next-line
          requirejs(['aaControls/lg.aa.config'], function (configAA) {
            configAA.adicionar('autoatendimento', '/Autoatendimento/Produtos/AA/Scripts');
            // eslint-disable-next-line
            requirejs(['jquery', 'autoatendimento/utils.foto'], ($, UtilsFoto) => {
              const utils = new UtilsFoto({ $elFoto: $('#avatarColaborador'), ...ref.usuarioConfiguracao }, true);

              utils.alterarFoto();
            });
          });
        }
      }
    },
  },
};
</script>
